<template>
    <div class="dots-spinner" v-bind:style="spinnerStyle">
        <div
            v-for="(ds, index) in dotsStyles"
            v-bind:key="index"
            class="dot"
            v-bind:style="ds"
        />
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent } from 'vue';

    export default defineComponent({
        name: 'DotsSpinner',
        props: {
            animationDuration: {
                type: Number,
                default: 1250,
            },
            dotSize: {
                type: Number,
                default: 1,
            },
            dotsNum: {
                type: Number,
                default: 3,
            },
            color: {
                type: String,
                default: '#81a5da',
            },
        },
        setup(props) {
            const horizontalMargin = computed(() => props.dotSize / 2);

            const spinnerStyle = computed(() => ({
                height: `${props.dotSize}rem`,
                width: `${(props.dotSize + horizontalMargin.value * 2) * props.dotsNum}rem`,
                padding: `${props.dotSize * 2}rem 0 ${props.dotSize * 3}rem`,
                margin: '0 auto',
            }));

            const dotStyle = computed(() => ({
                animationDuration: `${props.animationDuration}ms`,
                width: `${props.dotSize}rem`,
                height: `${props.dotSize}rem`,
                margin: `0 ${horizontalMargin.value}rem`,
                borderWidth: `${props.dotSize / 5}rem`,
                borderColor: props.color,
                background: props.color,
            }));

            const dotsStyles = computed(() => {
                const dotsStyles: Record<string, string>[] = [];
                const delayModifier = 0.3;
                const basicDelay = 1000;
                for (let i = 1; i <= props.dotsNum; i++) {
                    const style = { animationDelay: `${basicDelay * i * delayModifier}ms`, ...dotStyle.value };
                    dotsStyles.push(style);
                }
                return dotsStyles;
            });

            return {
                horizontalMargin,
                spinnerStyle,
                dotStyle,
                dotsStyles,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/spinner";
</style>
